/**
 * @description
 * Takes an Array<T>, and a grouping function,
 * and returns a Map of the array grouped by the grouping function.
 */
export const groupBy = (arr, key) => arr.reduce((groups, item) => {
    (groups[key(item)] ||= []).push(item);
    return groups;
}, {});
/**
 * @description
 * Takes an Array<K>, and separates it into two arrays, one with the elements that pass the predicate,
 * and one with the elements that don't.
 */
export function partition(array, condition) {
    return array.reduce(([pass, fail], elem) => {
        return condition(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    }, [[], []]);
}
const objectsAreEqual = (objA, objB) => {
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for (const key of keysA) {
        if (typeof objA[key] === 'object' && objA[key] !== null && typeof objB[key] === 'object' && objB[key] !== null) {
            if (!objectsAreEqual(objA[key], objB[key])) {
                return false;
            }
        }
        else if (objA[key] !== objB[key]) {
            return false;
        }
    }
    return true;
};
const getUniqueObjects = (arr) => {
    return arr.filter((obj, index) => index === arr.findIndex((otherObj) => objectsAreEqual(obj, otherObj)));
};
export const removeDuplicates = (arr1, arr2) => {
    const commonObjects = arr1.filter((objA) => arr2.some((objB) => objectsAreEqual(objA, objB)));
    const uniqueCommonObjects = getUniqueObjects(commonObjects);
    const uniqueArr1 = arr1.filter((objA) => !arr2.some((objB) => objectsAreEqual(objA, objB)));
    const uniqueArr2 = arr2.filter((objA) => !arr1.some((objB) => objectsAreEqual(objA, objB)));
    return [...uniqueCommonObjects, ...uniqueArr1, ...uniqueArr2];
};
//# sourceMappingURL=array.js.map